import React from "react";
import Helmet from "react-helmet";

import logo from "../../assets/redVideoSquirrelLogo.png";
import { Icon } from "../../atoms/Icon";
import useAuthState from "../../hooks/useAuthState";

import styles from "./OneColumnPage.module.scss";
import { Link } from "react-router-dom";

function OneColumnPage({ title, children, location }) {
  const { isLoggedIn, logout } = useAuthState();

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className={styles.root}>
        <div className={styles.navbarMenu}>
          <Link to="/">
            <img className={styles.logoImg} src={logo} alt="Video Squirrel" />
          </Link>

          <div className={styles.toolbarGroups}>
            {!isLoggedIn ? (
              <span className={styles.btnText}>
                <Link
                  to={{
                    pathname: "/influencer/login",
                    state: {
                      from: location
                    }
                  }}
                >
                  {" "}
                  SIGN IN
                </Link>
              </span>
            ) : (
              <span className={styles.btnText} onClick={logout}>
                {" "}
                SIGN OUT
              </span>
            )}
            <a
              href="https://help.videosquirrel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Icon color={"#cad8e4"} name="help" />
            </a>
          </div>
        </div>
        <div className={styles.gridContainer}>
          <div className={styles.centerGridItem}>{children}</div>
        </div>
      </div>
    </>
  );
}

export default OneColumnPage;
